import { variablemanual_standalone_accociation_value } from "typescript_helpers"
import { VM } from "./variablenmanual/Variablemanual2"
import { AdminGetAllUsers } from "./accountmanagement/AdminGetAllUsers"
import { test_jwt } from "../nonComponentFunctions/test_config"

export const Test = () => {
  return (
    <>
      <AdminGetAllUsers jwt={test_jwt}/>
      {/*
      <VM association={variablemanual_standalone_accociation_value}/>
      */}
    </>
  )
}
